import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import SetupWizard from '../components/setup-wizard/SetupWizard';
import MedicalSetupWizard from '../components/setup-wizard/medical/MedicalSetupWizard';

// Route /admin/setup-wizard — onboarding de clientes nuevos Citame (NER-3256).
// SuperAdmin only: mismo criterio que el resto del panel Nerdo-interno (email
// @nerdo.solutions, ver ActivityBar NER-3142). Un tenant normal que entre por
// URL directa recibe redirect a /unauthorized (AC1). El backend además gatea
// POST /admin/setup-org por allowlist SETUP_ADMIN_EMAILS (defensa en profundidad).
//
// Consultame (NER-3832): con `?vertical=medical` se sirve el wizard médico de 8
// pasos (Opción A: reuse admin Citame con feature-flag por vertical, NER-3656).
function SetupWizardPage() {
  const { user, loading } = useAuth();
  const [searchParams] = useSearchParams();

  if (loading) return null;

  const userEmail = (user?.attributes || user?.username || '').toLowerCase();
  const isNerdoAdmin = userEmail.endsWith('@nerdo.solutions');

  if (!isNerdoAdmin) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (searchParams.get('vertical') === 'medical') {
    return <MedicalSetupWizard />;
  }

  return <SetupWizard />;
}

export default SetupWizardPage;
